import { findTagByType } from '@eventbrite/redux-destination';
import isArray from 'lodash/isArray';
import last from 'lodash/last';
import { CATEGORY_TAG_TYPE, FORMAT_TAG_TYPE } from '../../constants';
import { DiscoverState, EventSearch } from '../../types/index';
import {
    formatDateRangeStringForDisplay,
    getSearchEventHeaderTitle,
} from '../../utils/general';

/**
 * Counts the currently selected filters
 * @param  {Object} state Current application state
 * @return {Nubmer}       Number of selected filters
 */
export const getSelectedFilterCount = (state: {
    search: { eventSearch: EventSearch };
}) => {
    const {
        search: { eventSearch },
    } = state;

    return (
        // Dates will be a string if no date is selected, else array
        // Dates always has at least "current_future" already, so don't count it
        (Array.isArray(eventSearch.dates) ? eventSearch.dates.length - 1 : 0) +
        // A custom date would show up in a different way
        (eventSearch.dateRange.to && eventSearch.dateRange.from ? 1 : 0) +
        // Categories and formats are both tags, and you can only select one of each right now
        eventSearch.tags.length +
        // Price is either undefined, paid or free
        (eventSearch.price !== undefined ? 1 : 0) +
        // Language and currency are both only able to select one
        eventSearch.currencies.length +
        (eventSearch.languages.length >= 1 ? 1 : 0)
    );
};

//If no date filter is applied the value will
//default to "current_future", if any filters
//are applied we will receive an array with
//both 'current_future' and whatever other
//filters. But that is only instance of more
//than one filter so we can feel safe returning
//the second option.
export const getSelectedDate = (
    date?: string[],
    { from: startDate, to: endDate }: { from?: string; to?: string } = {},
) => {
    let dateToReturn;

    if (isArray(date)) {
        dateToReturn = last(date) === 'current_future' ? undefined : last(date);
    }

    if (startDate && endDate) {
        dateToReturn = formatDateRangeStringForDisplay({ startDate, endDate });
    }

    return dateToReturn;
};

export const getSelectedCategory = (tags?: string[]) =>
    findTagByType(CATEGORY_TAG_TYPE, tags);
export const getSelectedFormat = (tags?: string[]) =>
    findTagByType(FORMAT_TAG_TYPE, tags);

export const getSearchHeaderTitle = (
    state: Pick<DiscoverState, 'botH1' | 'location' | 'search'>,
) => {
    if (state.botH1) {
        return state.botH1;
    }

    return getSearchEventHeaderTitle(
        {
            currentPlace: state.location?.currentPlace || '',
            currentPlaceParent: state.location?.currentPlaceParent || '',
            placeType: state.location?.placeType,
        },
        {
            eventSearch: state.search.eventSearch,
        },
    );
};
